import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { FormControl } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog'
import { DialogData } from './gb-confirm-dialog-data'
import { TranslateModule } from '@ngx-translate/core'
import { MatIconModule } from '@angular/material/icon'
import { MatButtonModule } from '@angular/material/button'
import { GbSafePipe } from 'libs/shared/utils/pipes/src/lib/gb-safe-pipe/gb-safe.pipe'

@Component({
  selector: 'gb-confirm-dialog',
  imports: [TranslateModule, MatDialogModule, MatIconModule, MatButtonModule, GbSafePipe],
  templateUrl: './gb-confirm-dialog.component.html',
  styleUrl: './gb-confirm-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbConfirmDialogComponent {
  public dialogData: DialogData = inject(MAT_DIALOG_DATA)

  checkboxControl = new FormControl(false)

  get cancelButtonText(): string {
    return this.dialogData.cancelButtonText ?? 'CANCEL'
  }

  get confirmButtonText(): string {
    return this.dialogData.confirmButtonText ?? 'CONFIRM'
  }
}
